import React from "react";
import {Container, Grid, Header,} from "semantic-ui-react";
import {FormattedMessage} from "react-intl";
import {APP} from "../../../constants";
import TinySlider from "tiny-slider-react";

export const App = ({subdomain, details}) => {

    const {about_title, about_text, about_image} = details;

    let style = {
        margin: '0 auto'
    };

    if (about_image) {
        style = {
            backgroundImage: `url(${APP.cities}/about_image/${about_image})`
        };
    }

    const settings = {
        lazyload: true,
        nav: true,
        navPosition: 'bottom',
        controls: false,
        mouseDrag: true,
        loop: false,
        items: 1,
        responsive: {
            420: {
                items: 1
            }
        }
    };

    return (
        <Container as="section" fluid className="section-app">
            <Grid stackable columns="equal">
                <Grid.Column>
                    <div className="content">
                        <Header as="h2">
                            {
                                about_title || <FormattedMessage id="IN BH sempre com você"/>
                            }
                        </Header>
                        <div dangerouslySetInnerHTML={{__html: about_text}}/>
                    </div>
                </Grid.Column>
                <Grid.Column
                    // only={'large screen'}
                    style={style}
                >
                    {
                        subdomain !== 'europa' && <TinySlider settings={settings}>
                            <div>
                                <div style={{position: 'relative', overflow: 'hidden', paddingBottom: '56.25%'}}>
                                    {/*<video style={{position: "absolute"}} width="100%" height="100%" controls>*/}
                                    {/*    <source src="/apresentacao.mp4" type="video/mp4"/>*/}
                                    {/*    Seu navegador não suporta a tag de vídeo.*/}
                                    {/*</video>*/}
                                    <iframe style={{position: "absolute"}} title="Ciclo Do Tempo"
                                            src="https://www.youtube.com/embed/POzol-Is19w?si=Ccv-_hzGZWUoWjre" width="100%" height="100%"
                                            frameBorder="0" scrolling="auto" allowFullScreen="allowfullscreen"></iframe>
                                </div>
                            </div>
                            {/*<div>*/}
                            {/*    <div style={{position: 'relative', overflow: 'hidden', paddingBottom: '56.25%'}}>*/}
                            {/*        <iframe style={{position: "absolute"}} title="Ciclo Do Tempo"*/}
                            {/*                src="https://cdn.jwplayer.com/players/sZh4T50y-RpOnGSv6.html" width="100%" height="100%"*/}
                            {/*                frameBorder="0" scrolling="auto" allowFullScreen="allowfullscreen"></iframe>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            {/*<div>*/}
                            {/*    <div style={{position: 'relative', overflow: 'hidden', paddingBottom: '56.25%'}}>*/}
                            {/*        <iframe style={{position: "absolute"}} title="Ciclo Do Tempo"*/}
                            {/*                src="https://cdn.jwplayer.com/players/CEpJS1MG-RpOnGSv6.html" width="100%" height="100%"*/}
                            {/*                frameBorder="0" scrolling="auto" allowFullScreen="allowfullscreen"></iframe>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </TinySlider>
                    }
                </Grid.Column>
            </Grid>
        </Container>
    );
};
